import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import * as ApiCalls from "./Servings/ApiCalls.tsx";

import Loading from "./Servings/Loading.tsx";
import ErrorPage from "./ErrorPage.tsx";
import NotFoundPage from "./NotFoundPage.tsx";
import NavigationBar from "./Servings/NavigationBar.tsx";
import DescriptionBox from "./Servings/DescriptionBox.tsx";
import CoverColumn from "./Servings/CoverColumn.tsx";

import { convertBookInfo, changePageTitle, refineBookId } from "./Utils.ts";

import "../style/general.css";

import { VippsStatusType } from "./Types/PaymentStatusResponse.ts";
import { ErrorType } from "./Types/ErrorType.ts";
import TitleAndAuthors from "./Servings/TitleAndAuthors.tsx";

export default function CompletePage() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<ErrorType>();
  const [bookInfo, setBookInfo] = useState<any>(null);
  const [vippsState, setVippsState] = useState<VippsStatusType>(VippsStatusType.created);
  const [lovdataBookLink, setLovdataBookLink] = useState<string>("");

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();

  const transactionId = query.get("transactionid");
  const bookIdQuery = query.get("bookid") ?? "";
  const bookId = refineBookId(bookIdQuery);

  //get the info of book to display it
  useEffect(() => {
    getBook();
    checkVippsTransaction();
  }, []);

  const getBook = async () => {
    if (bookId) {
      ApiCalls.getBook(bookId)
        .then(async (response: any) => {
          const newBookInfo = convertBookInfo(response, bookId);
          if (newBookInfo != false) {
            setBookInfo(newBookInfo);
            changePageTitle(newBookInfo.title);
            if (process.env.REACT_APP_ENVIRONMENT == "production") {
              setLovdataBookLink("https://lovdata.no/pro/#document/KARNOV/" + bookId);
            } else {
              setLovdataBookLink("https://stage.lovdata.no:8087/pro/#document/KARNOV/" + bookId);
            }
          } else {
            console.log("bookInfo is false");
            setError(ErrorType.NoMetadataForBook);
          }
        })
        .catch((err) => {
          console.log("failed to get book", err);
          setError(ErrorType.BFFAPICallError);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setError(ErrorType.BookIdNotFound);
    }
  };

  const checkVippsTransaction = async () => {
    if (transactionId) {
      ApiCalls.checkVippsTransaction(transactionId)
        .then(async (response: any) => {
          if (response?.state) {
            setVippsState(response.state.toLowerCase());
            if (response.state.toLowerCase() == VippsStatusType.created) {
              setTimeout(() => {
                checkVippsTransaction();
              }, 10000);
            }
          } else {
            console.log("No state in response.");
            setVippsState(VippsStatusType.error);
            setError(ErrorType.VippsAPICallError);
          }
        })
        .catch((error) => {
          console.log("failed checkVippsTransaction ", error);
          setVippsState(VippsStatusType.error);
          setError(ErrorType.VippsAPICallError);
        });
    } else {
      setError(ErrorType.TransactionIdNotFound);
    }
  };

  return (
    <>
      {error ? (
        <ErrorPage errorType={error} bookInfo={bookInfo ?? ""} />
      ) : (
        <>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <NavigationBar bookInfo={bookInfo} />
              {vippsState === "authorized" && (
                <div style={{ marginTop: "2rem" }}>
                  Du har nå kjøpt {bookInfo.title}. Publikasjonen kan du lese i Lovdata Pro Karnov i denne{" "}
                  <a target="_blank" rel="noopener noreferrer" href={lovdataBookLink}>
                    lenken
                  </a>
                  .
                </div>
              )}
              <div style={{ fontWeight: "bold", fontSize: "20px", marginTop: "2rem" }}>
                {vippsState === VippsStatusType.error && <div>Noe gikk galt med betalingen. Vennligst prøv igjen.</div>}
                {vippsState === VippsStatusType.aborted && <div>Betalingen er avsluttet.</div>}
                {vippsState === VippsStatusType.created && <div>Betalingen er under behandling. Vennligst vent.</div>}
                {vippsState === VippsStatusType.cancelled && <div>Betalingen ble avbrutt.</div>}
                {vippsState === VippsStatusType.expired && <div>Betalingen er utløpt.</div>}
                {vippsState === VippsStatusType.refunded && <div>Betalingen er refundert.</div>}
              </div>

              <div className="main-container">
                <CoverColumn bookInfo={bookInfo} />
                <div className="second-column">
                  <TitleAndAuthors bookInfo={bookInfo} />

                  <div className="ExtraInfoContainer">
                    <div>
                      <strong>Digital utgave:</strong> Lovdata Pro Karnov
                    </div>
                    <div>
                      <strong>Umiddelbart tilgang</strong>
                    </div>
                  </div>
                </div>
              </div>
              <DescriptionBox bookInfo={bookInfo} />
            </>
          )}
        </>
      )}
    </>
  );
}
